<template>
  <va-inner-loading :loading="isLoading" style="width: 100%;" color="primary">

    <div class="row content-list">
      <div class="flex operation-content invitation" v-for="(item,idx) in dataList" :key="idx">
        <img :src="item.HeadPic || require('@/static/images/headDefault.jpg')" alt="" class="user-photo">
        <div>
          <div style="position:relative;padding-right: 16px;display: flex;
    align-items: center;">
            <router-link :to="{path:'/admin/forum/postsPage/postsContent',query:{searcharticle:item.ID}}" class="link-a"
                         tag="a">{{ item.Title }}
            </router-link>
            <div class="posts-tab boutique" v-if="item.IsTop != 0 && item.IsTop != null">顶</div>
            <div class="posts-tab stick" v-if="item.IsElite != 0 && item.IsElite != null">精</div>
            <div class="posts-tab official" v-if="item.IsSys != 0 && item.IsSys != null">官</div>
          </div>
          <div>
            <span style="font-size: 13px;
    color: #333;">[{{ item.LabelName != null ? item.LabelName.slice(0, -1) : '' }}]</span>
            <span class="user-name">{{ item.alias }}</span>
            <span class="user-name">{{ item.ModiferTime }}</span>
          </div>
        </div>
        <div class="bubble">{{ item.ReplyCount }}</div>
      </div>
    </div>

    <div>
      <vxe-pager
        background
        v-model:current-page="tablePager.currentPage"
        v-model:page-size="tablePager.pageSize"
        :total="tablePager.totalResult"
        @page-change="handlePageChange"
        :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']">
      </vxe-pager>
    </div>

  </va-inner-loading>
</template>
<script>
import {reactive} from 'vue';
import Qs from 'qs'

export default {
  name: "postsList",
  props: {
    pushdata: {
      type: Array,
      default: () => []
    }
  },
  components: {},
  watch: {
    pushdata: {
      handler(newValue, oldValue) {
        this.findData()
      }
    }
  },
  data() {

    const tablePager = reactive({
      currentPage: 1,
      pageSize: 10,
      totalResult: 0
    })
    const toolbar = reactive({
      loading: false,
      formData: {
        searchKey: ''
      }
    })
    return {
      isLoading: false,
      tableData: null,
      tablePager,
      toolbar,
      dataList: []
    }
  },
  methods: {
    findData(changParams) {
      let params = this.pushdata;
      console.log('postsList');
      console.log(params)
      if (changParams) {
        params.currentPage = this.tablePager.currentPage;
        params.pageSize = this.tablePager.pageSize;
      }
      this.isLoading = true;
      this.$api.formsAPI.getForumArticle(Qs.stringify(params))
        .then(res => {
          if (res.data.Success == false) {
            VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
            return;
          }
          this.dataList = res.data.Data.dataTable;
          // this.$store.commit('updateSearchData','');
          this.tablePager.totalResult = res.data.Data.totalResult;
          this.tablePager.currentPage = res.data.Data.currentPage;
          this.tablePager.pageSize = res.data.Data.pageSize;
          this.$emit('postsRes', res.data.Data)
          console.log('getForumArticle')
          console.log(res.data.Data.dataTable)
          this.isLoading = false;

          //将选择的板块和标签保存起来，做面包屑
          let forumPageData = {
            sectionID: params.SectionID,
            sectionName: params.SectionName,
            labelID: params.Label,
            labelName: params.labelName,
            pageIndex: this.tablePager.currentPage,
            pageSize: this.tablePager.pageSize,
            TimeSpan: params.TimeSpan,
            Order: params.Order
          };
          console.log('updateForumPageData postList')
          console.log(forumPageData)
          this.$store.commit('updateForumPageData', forumPageData)
        })
        .catch(error => {
          console.log(error);
        })
    },
    handlePageChange() {
      this.findData(1);
    },
  },
}
</script>
<style>
.inner-loading__spinner {
  -webkit-animation: va-icon--spin-animation 1.5s linear infinite;
  animation: va-icon--spin-animation 1.5s linear infinite;
  animation-direction: reverse;
}


@-webkit-keyframes va-icon--spin-animation {
  0% {
    transform: rotate(0deg)
  }

  to {
    transform: rotate(1turn)
  }
}

@keyframes va-icon--spin-animation {
  0% {
    transform: rotate(0deg)
  }

  to {
    transform: rotate(1turn)
  }
}
</style>
<style scoped lang="scss">

.bubble {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  margin-right: 30px;
  padding: 3px 8px;
  background-color: #f0f7ff;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  font-size: 13px;
  color: #333;
  line-height: normal;
  margin-left: 10px;
}

.bubble::before {
  content: "";
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  left: -8px;
  display: inline-block;
  width: 0;
  height: 0;
  border-width: 4px;
  border-style: solid;
  border-color: transparent #ebf2fa transparent transparent;
}

.content-list {
  position: relative;
  height: 800px;
  align-items: start;
  flex-direction: column;
  overflow-y: scroll;
  flex-wrap: nowrap;
}

.content-list::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}

.sanjiao {
  padding: 2px 4px;

  border-radius: 4px;
  font-size: 12px;
  color: rgb(51, 51, 51);
  background: rgb(240, 247, 255);
  position: absolute;
  // right: 2px;
}

.sanjiao::before {
  content: "";
  width: 0px;
  height: 0px;
  border-width: 0px 8px 8px;
  border-style: solid;
  border-color: transparent transparent rgb(240, 247, 255);
  display: block;
  transform: rotate(-90deg);
  position: relative;
  position: absolute;
  left: -10px;
  top: 6px;
}

.invitation {
  .posts-tab {
    display: flex;
    align-items: center;
    line-height: 12px;
    text-align: center;
    padding: 3px;
    border-radius: 4px;
    font-size: 12px;
    color: #ffffff;
    margin: 0 3px;
  }

  .official {

    background: #5b95f9;
  }

  .stick {

    background: #e63e3b;
  }

  .boutique {

    background: #fa8429;
  }

  align-items: flex-end;
  display: flex;

  .link-a {
    position: relative;
    // max-width:220px;
    font-weight: 800;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
  }

  .user-name {
    color: #999;
    margin-left: 10px;
    font-size: 12px;
  }

  .user-photo {
    display: inline-block;
    vertical-align: top;
    width: 46px;
    height: 46px;
    margin-right: 10px;
    border-radius: 50%;
  }
}

</style>
